// Kept dependency-free so leaf components (e.g. table badges) can share the
// resolution chart colors without pulling in the RTK Query service graph.
export const RESOLUTION_CHART_COLORS = {
  automated: '#2FA7B8',
  contained: '#3AA89F',
  nonAutomated: '#A3A8B2',
  verified: '#006B5F',
} as const;
